import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedClassId,
  setSelectedSubjectId,
  setSelectedYear,
} from "./redux/slice";
import {
  fetchClassesThunk,
  fetchSubjectsByClassThunk,
} from "../chapter/redux/chapterThunk";

export default function UploadSamplePaper() {
  const dispatch = useDispatch();
  const {
    classes,
    subjects,
    selectedClassId,
    selectedSubjectId,
    loadingSubjects,
  } = useSelector((state) => state.samplePaper);

  const [pdfFile, setPdfFile] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    dispatch(fetchClassesThunk());
  }, [dispatch]);

  useEffect(() => {
    if (selectedClassId) dispatch(fetchSubjectsByClassThunk(selectedClassId));
  }, [dispatch, selectedClassId]);

  const handleFileChange = (e) => setPdfFile(e.target.files?.[0] || null);

  const handleUpload = () => {
    const formData = new FormData();
    formData.append("class_id", selectedClassId);
    formData.append("subject_id", selectedSubjectId);
    formData.append("file", pdfFile);

    // Convert FormData entries into an array and use map to display
    const formDataEntries = Array.from(formData.entries());

    formDataEntries.map(([key, value]) => {
      console.log(`${key}:`, value);
      return null; // map needs a return, but we're just logging
    });

    alert("File Uploaded Successfully");
    window.location.reload();
  };

  return (
    <div className="container-fluid py-2 font-inter">
      <h3 className="text-3xl font-bold text-center mb-6 text-gray-800">
        Upload Sample Paper
      </h3>

      <div className="bg-white shadow rounded-3 p-4 max-w-4xl mx-auto">
        {/* Class & Subject */}
        <div className="row mb-4">
          {/* Class */}
          <div className="col-md-6 mb-3 mb-md-0">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Select Class:
            </label>
            <select
              value={selectedClassId}
              onChange={(e) => {
                dispatch(setSelectedClassId(e.target.value));
                dispatch(setSelectedSubjectId(""));
              }}
              className="w-full p-2 border border-gray-300 rounded-md"
              style={{ width: "70%", marginLeft: "4%" }}
            >
              <option value="">-- Select Class --</option>
              {classes?.map((cls) => (
                <option key={cls.class_id} value={cls.class_id}>
                  {cls.class_name}
                </option>
              ))}
            </select>
          </div>
          {/* {selectedClassId ? "hi" : "hello"} */}
          {/* Subject */}
          <div className="col-md-6">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Select Subject:
            </label>
            <select
              value={selectedSubjectId}
              onChange={(e) => dispatch(setSelectedSubjectId(e.target.value))}
              //   className="w-full p-2 border border-gray-300 rounded-md"
              disabled={!selectedClassId || loadingSubjects}
              style={{
                width: "70%",
                marginLeft: "4%",
                height: "5vh",
                // backgroundColor: !selectedClassId ? "" : "#e9ecef",
                // border: !selectedClassId ? "" : "#DEE2E6",
              }}
            >
              <option value="">-- Select Subject --</option>
              {subjects?.map((sub) => (
                <option key={sub.subject_id} value={sub.subject_id}>
                  {sub.subject_name}
                </option>
              ))}
            </select>
          </div>
        </div>
        {false && (
          <div className="row mb-4">
            {/* Class */}
            <div className="col-md-6 mb-3 mb-md-0">
              <input
                ref={fileInputRef}
                type="file"
                accept=".pdf"
                className="form-control"
                disabled={!selectedClassId || !selectedSubjectId}
                onChange={handleFileChange}
              />
            </div>
            {/* {selectedClassId ? "hi" : "hello"} */}
            {/* Subject */}
            <div className="col-md-6" style={{ display: "flex", gap: "2%" }}>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Name of the file:
              </label>
              <input
                type="text"
                className="form-control"
                style={{ width: "70%" }}
              />
            </div>
          </div>
        )}
        {/* File Upload */}
        <div className="row align-items-center">
          <div className="col-md-6 mb-3 mb-md-0" style={{ display: "flex" }}>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Name of the file
            </label>
            <input
              ref={fileInputRef}
              type="file"
              accept=".pdf"
              className="form-control"
              disabled={!selectedClassId || !selectedSubjectId}
              onChange={handleFileChange}
            />
          </div>
          <div className="col-md-4 text-end">
            <button
              className={`btn btn-success w-100 ${
                !pdfFile ? "opacity-50 cursor-not-allowed" : ""
              }`}
              disabled={!pdfFile || !selectedClassId || !selectedSubjectId}
              onClick={handleUpload}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export function ViewUploadedSamplePaper() {
  const dispatch = useDispatch();
  const {
    classes,
    subjects,
    selectedClassId,
    selectedSubjectId,
    loadingSubjects,
    selectedYear,
  } = useSelector((state) => state.samplePaper);

  useEffect(() => {
    dispatch(fetchClassesThunk());
  }, [dispatch]);

  useEffect(() => {
    if (selectedClassId) dispatch(fetchSubjectsByClassThunk(selectedClassId));
  }, [dispatch, selectedClassId]);

  // Generate years 2010 → current year
  const years = Array.from(
    { length: new Date().getFullYear() - 2009 },
    (_, i) => 2010 + i
  );
  // Temporary mock data (replace later with API)
  const uploadedPapersMock = [
    {
      id: 5,
      class_id: 8, // Class 7
      subject_id: 16, // Hindi Literature
      year: "2020",
      subject_name: "Hindi Literature",
      file_name: "Class7_HindiLit_2020.pdf",
    },
    {
      id: 4,
      class_id: 5, // Class 4
      subject_id: 17, // EVS
      year: "2021",
      subject_name: "EVS",
      file_name: "Class4_EVS_2021.pdf",
    },
    {
      id: 1,
      class_id: 24, // Class 10
      subject_id: 4, // Science
      subject_name: "Biology",
      year: "2022",
      file_name: "Class10_Science_2022.pdf",
    },
    {
      id: 2,
      class_id: 23, // Class 9
      subject_id: 33, // English Grammar
      subject_name: "Chemistry", // English Grammar
      year: "2023",
      file_name: "Class9_EnglishGrammar_2023.pdf",
    },
    {
      id: 3,
      class_id: 25, // Class 11
      subject_id: 36, // Computer Science
      subject_name: "Business Studies", // Computer Science
      year: "2024",
      file_name: "Class11_ComputerScience_2024.pdf",
    },
  ];
  // Filter uploaded papers dynamically
  const filteredPapers = uploadedPapersMock.filter(
    (paper) =>
      (!selectedClassId || paper.class_id === Number(selectedClassId)) &&
      (!selectedSubjectId || paper.subject_id === Number(selectedSubjectId)) &&
      (!selectedYear || paper.year === selectedYear)
  );

  return (
    <div className="container-fluid py-2 font-inter">
      <h3 className="text-3xl font-bold text-center mb-6 text-gray-800">
        View Uploaded Sample Paper(s)
      </h3>

      <div className="bg-white shadow rounded-3 p-4 max-w-4xl mx-auto">
        <div className="row mb-4">
          {/* Class */}
          <div className="col-md-4 mb-3 mb-md-0">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Class:
            </label>
            <select
              value={selectedClassId}
              onChange={(e) => {
                dispatch(setSelectedClassId(e.target.value));
                dispatch(setSelectedSubjectId(""));
              }}
              style={{ width: "80%", marginLeft: "4%" }}
              className="w-full p-2 border border-gray-300 rounded-md"
            >
              <option value="">-- Select Class --</option>
              {classes?.map((cls) => (
                <option key={cls.class_id} value={cls.class_id}>
                  {cls.class_name}
                </option>
              ))}
            </select>
          </div>

          {/* Subject */}
          <div className="col-md-4 mb-3 mb-md-0">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Subject:
            </label>
            <select
              value={selectedSubjectId}
              onChange={(e) => dispatch(setSelectedSubjectId(e.target.value))}
              className="w-full p-2 border border-gray-300 rounded-md"
              disabled={!selectedClassId || loadingSubjects}
              style={{ width: "80%", marginLeft: "2%" }}
            >
              <option value="">-- Select Subject --</option>
              {subjects?.map((sub) => (
                <option key={sub.subject_id} value={sub.subject_id}>
                  {sub.subject_name}
                </option>
              ))}
            </select>
          </div>

          {/* Year */}
          <div className="col-md-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Year:
            </label>
            <select
              value={selectedYear}
              onChange={(e) => dispatch(setSelectedYear(e.target.value))}
              className="w-full p-2 border border-gray-300 rounded-md"
              style={{ width: "70%", marginLeft: "4%" }}
            >
              <option value="">-- Select Year --</option>
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Future Section: List of Uploaded PDFs */}
        {filteredPapers.length > 0 ? (
          <div className="table-responsive p-2 rounded-3">
            <table className="table table-striped table-bordered text-15">
              <thead>
                <tr className="bg-gray-200 text-gray-700">
                  <th className="text-center">#</th>
                  <th className="text-center">Class</th>
                  <th className="text-center">Subject</th>
                  <th className="text-center">Year</th>
                  <th className="text-center">File Name</th>
                  <th className="text-center" style={{ minWidth: "110px" }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredPapers.map((paper, index) => {
                  const className =
                    classes.find((cls) => cls.class_id === paper.class_id)
                      ?.class_name || "-";
                  const subjectName =
                    subjects.find((sub) => sub.subject_id === paper.subject_id)
                      ?.subject_name || "-";

                  return (
                    <tr key={paper.id} className="hover:bg-gray-100">
                      <td className="text-center">{index + 1}</td>
                      <td className="text-center">{className}</td>
                      <td className="text-center">
                        {/* {subjectName} */}
                        {paper.subject_name}
                      </td>
                      <td className="text-center">{paper.year}</td>
                      <td className="text-center">{paper.file_name}</td>
                      <td className="text-center">
                        <div className="flex justify-center space-x-2">
                          <button
                            className="btn btn-sm btn-outline-success transition duration-200 shadow-sm"
                            title="View Paper"
                          >
                            <i className="bi bi-eye"></i>
                          </button>
                          <button className="btn btn-sm btn-outline-primary transition duration-200 shadow-sm">
                            <i className="bi bi-pencil-square"></i>
                          </button>
                          <button className="bg-red-500 btn btn-sm btn-outline-danger hover:bg-red-600 transition duration-200 shadow-sm">
                            <i className="bi bi-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <p style={{ textAlign: "center", color: "red" }}>
            No records found for the selected filters.
          </p>
        )}
      </div>
    </div>
  );
}
